export const prStates = [{ value: 'PR', label: 'PR' }]
